
import { useState } from "react";
import { Link } from "react-router-dom";
import {
  Image,
  ShieldCheck,
  Pill,
  ShoppingCart,
  PlusCircle,
  ChevronLeft, Package
} from "lucide-react";

import { usePrescriptionCart } from "../../context/pharmacy/PrescriptionCartContext";



import ImagePrescriptionForm from "../../components/pharmacy/ImagePrescriptionForm";
import InsurancePrescriptionForm from "../../components/pharmacy/InsurancePrescriptionForm";
import OTCPrescriptionForm from "../../components/pharmacy/OTCPrescriptionForm";
import PharmacyOrders from "../Dashboard/Pharmacy/PharmacyOrders";

import "./Prescription.css";

export default function Prescription() {
  const { items } = usePrescriptionCart();

  const [showRegistrationOptions, setShowRegistrationOptions] =
    useState(false);

  const [showOrders, setShowOrders] = useState(true);

  const [activeTab, setActiveTab] = useState(null);

  const cartCount = items?.length || 0;

  const prescriptionOptions = [
    {
      id: "image",
      title: "عکس نسخه",
      icon: Image,
    },
    {
      id: "insurance",
      title: "نسخه الکترونیک بیمه",
      icon: ShieldCheck,
    },
    {
      id: "otc",
      title: "داروهای بدون نسخه",
      icon: Pill,
    },
  ];

  const handleRegisterPrescription = () => {
    setShowRegistrationOptions(true);
    setActiveTab(null);
  };

  const handleTabChange = (tab) => {
    setActiveTab(tab);
  };

  return (
    <section className="prescription-page" dir="rtl">

      
    <div className="wrapper">
      <h2>
        <span> نسخه های من </span>
      </h2>
      </div>

      {/* Initial actions */}
      <div className="prescription-main-actions">



        {/* Register Prescription */}
        <button
          type="button"
          className="prescription-main-button prescription-register-button"
          onClick={() => {
            setShowRegistrationOptions(true);
            setShowOrders(false);
            setActiveTab(null);
          }}
        >
          <PlusCircle size={22} />
          <span>ثبت نسخه</span>
          <ChevronLeft size={18} />
        </button>

        {/* My Orders */}
        <button
          type="button"
          className="prescription-main-button prescription-orders-button"
          onClick={() => {
            setShowOrders(true);
            setShowRegistrationOptions(false);
            setActiveTab(null);
          }}
        >
          <Package size={22} />
          <span>سفارشات من</span>
          <ChevronLeft size={18} />
        </button>


        {/* Prescription Cart */}
        <Link
          to="/dashboard/pharmacy/prescription-cart"
          onClick={(e) => {
            if (cartCount === 0) {
              e.preventDefault();
            }
          }}
          aria-disabled={cartCount === 0}
          className={`prescription-main-button prescription-cart-button ${cartCount === 0 ? "disabled" : ""
            }`}
        >
          <ShoppingCart size={22} />

          <span>سبد نسخه‌ها</span>

          {cartCount > 0 && (
            <span className="prescription-cart-count">
              {cartCount.toLocaleString("fa-IR")}
            </span>
          )}

          <ChevronLeft size={18} />
        </Link>

      </div>

      {/* Prescription registration options */}
      {showRegistrationOptions && (
        <div className="prescription-registration-section">

          <div className="prescription-options">

            {prescriptionOptions.map((option) => {
              const Icon = option.icon;

              return (
                <button
                  key={option.id}
                  type="button"
                  className={`prescription-option-button ${activeTab === option.id ? "active" : ""
                    }`}
                  onClick={() => handleTabChange(option.id)}
                >
                  <Icon size={25} />
                  <span>{option.title}</span>
                  <ChevronLeft size={17} />
                </button>
              );
            })}

          </div>

          {/* Selected form */}
          <div className="prescription-form-container">

            {activeTab === "image" && (
              <ImagePrescriptionForm />
            )}

            {activeTab === "insurance" && (
              <InsurancePrescriptionForm />
            )}

            {activeTab === "otc" && (
              <OTCPrescriptionForm />
            )}

          </div>

        </div>
      )}

      {/* Pharmacy orders always visible */}
      {showOrders && <PharmacyOrders />}

    </section>
  );
}
